module.exports = __webpack_public_path__ + "img/arrow_next@3x.ba678ddf.png";